import React, { FC } from "react";
import { SignInOrSignUp } from "./SignInOrSignUp";

export const SignUpPage: FC = () => {
  return <SignInOrSignUp variant="signUp" />;
};
